export default class EvaluationError extends Error {
  readonly reporter = "client:evaluation"

  constructor(error: Error) {
    super(error.message)
    this.name = "EvaluationError"
    this.stack = error.stack
  }
}
